import React from 'react';
import clsx from 'clsx';

import {
  getWorkOrderStatusColor,
  getWorkOrderStatusDescription,
} from '@atom/utilities/workOrderStatusUtilities';

import classes from './workOrderStatusPill.module.css';

interface Props {
  statusId: string | number;
  className:
    | ''
    | 'table'
    | 'detail'
    | 'bulk-modal'
    | 'detail-pane'
    | 'dashboard-map-list';
  style?: React.CSSProperties;
}

const WorkOrderStatusPill = ({ statusId, className, style }: Props) => {
  const pillStyle = {
    backgroundColor: getWorkOrderStatusColor(statusId),
  };

  return (
    <span
      className={clsx(
        classes.workOrderStatusPill,
        className && classes[className],
      )}
      style={{ ...pillStyle, ...style }}
    >
      {getWorkOrderStatusDescription(statusId)}
    </span>
  );
};

export default WorkOrderStatusPill;
